import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../styles/call-button.css";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export const CallButton = () => {
    return (
        <div className="button-container">
            <button 
                className="v-call-button"
                onClick={() => window.location.href = "tel:tel:+4917622006681"}
            >
                <FontAwesomeIcon icon={faPhone}  />
            </button>
        </div>
    )
}

export const WhatsAppButton = () => {
     return (
        <div className="wh-button-container">
            <button 
                className="whatsapp-button"
                onClick={() => window.location.href = "https://wa.me/+4917622006681"}
            >
                <FontAwesomeIcon icon={faWhatsapp} />
            </button>
        </div>
    )
}